import gql from 'graphql-tag';

import { courseCategoryFragment } from '~/shared/graphql-queries/course-categories/index';

export default gql`
  query findByIdCourseCategoryQuery($_id: MongoID!) {
    findByIdCourseCategoryQuery(_id: $_id) {
      ...CourseCategoryFragment
    }
  }
  ${courseCategoryFragment}
`;
